import dayjs from "dayjs";
import { create } from "zustand";
import { GetServiceTicketParams } from "~/services/service-ticket";


export type DispatchStates = {
  filters: GetServiceTicketParams;
};

type DispatchActions = {
  setFilters: (filters: GetServiceTicketParams) => void;
};

const initialStates = {
  filters: {
    page: 1,
    startDate: dayjs().toISOString(),
  },
};

export const useDistpachStore = create<DispatchStates & DispatchActions>()(
  (set) => ({
    ...initialStates,
    setFilters: (filters) =>
      set((state) => ({
        filters: {
          ...state.filters,
          ...filters,
        },
      })),
  })
);
